'use client';

import { createContext, useContext } from 'react';
import useCorporateDeals from '@/creditflowresearch/application/Deal/contexts/IssueTile/useCorporateDeals';

type CorporateContextType = ReturnType<typeof useCorporateDeals>;

export const CorporateContext = createContext<CorporateContextType>(null);

export const useCorporateContext = () => {
  const context = useContext(CorporateContext);
  if (!context) {
    throw new Error('useCorporateContext must be used within the CorporateContext');
  }
  return context;
};

const CorporateContextProvider = ({
  children,
  deals,
  fetch,
  additionalFilters,
}) => {
  const value = useCorporateDeals({
    deals,
    fetch,
    additionalFilters,
  });

  return (
    <CorporateContext.Provider value={ value }>
      { children }
    </CorporateContext.Provider>
  );
};

export default CorporateContextProvider;
